
const crms = [
    'Adobe Analytics', 'Google Analytics', 'SAP Hybris', 'Marketo', 'Hubspot', 'Infusionsoft', 'Salesforce',
    'Microsoft Dynamics', 'SugarCRM', 'Oracle', 'In-house', 'SAP C4C', 'Freshdesk', 'Zendesk',
    'RightNow', 'Service Cloud', 'Desk', 'SAP', 'Workday', 'Quickbooks', 'Netsuite',
    'Peoplesoft', 'Gmail', 'Outlook', 'Improveit! 360', 'ConnectWise', 'Autotask', 'Jungo',
    'Close.io', 'Insightly', 'Streak', 'Infor', 'JobScience', 'Apto', 'Property Base',
    'Financial Force', 'REthink CRM', 'Navatar', 'Dealer Team', 'Oracle Sales Cloud', 'SmartOffice',
    'Advologix', 'Bullhorn', 'CloudCC', 'DealerTrack', 'Google Apps', 'SalesforceIQ', 'Target Recruit',
].sort();

const phones = [
    '4com', 'Aastra', 'Aastrapbx', 'Activepbx', 'Ai Tech', 'Aitech', 'Alcatelpbx', 'Allworx',
    'Altigen', 'Amcom', 'Amernet', 'Anpi', 'Asterisk', 'Auerswald', 'Avaya', 'Avaya Aura',
    'Avaya Communication Manager', 'Bek', 'Bell', 'Bicompbxware', 'Bluip', 'Broadband Solutions',
    'Broadcloud', 'Broadsmart', 'Broadsoft', 'Broadvoice', 'Btpbx', 'Bullseye', 'Bvoip', 'Charterbusiness',
    'Cincinattibell', 'Cincinnati Bell', 'Cisco', 'Ciscopbx', 'Clearspan', 'Comcast', 'Comcast Business',
    'Cox', 'Dialpad', 'Digium Switchvox', 'Dsci', 'Eightbyeight', 'Eightbyeightpbx', 'Elastix', 'Esi',
    'Evaluation', 'Evolve Ip', 'Evolveip', 'Example Bsp', 'Fonality', 'Free Pbx', 'Freepbx', 'Fusion',
    'Fuze', 'Genericsip', 'Genesys', 'Grandstream', 'Grasshopper', 'Gts', 'Impulse', 'Ipex', 'Ipfone',
    'Ipfx', 'Ipitimi', 'Iptimi', 'Iristel', 'Jive', 'Lgpbx', 'Linksys', 'M5pbx', 'Masergy', 'Mcm',
    'Microsoft Lync', 'Mitel', 'Mitelpbx', 'Multitel', 'Nec', 'Netsapiens', 'Nexogy', 'Next Level',
    'Nextiva', 'Nextlevel', 'Nfon', 'Nortel', 'Novum', 'Panasonic', 'Panasonicpbx', 'Phonecom', 'Piaf',
    'Polycom', 'Rcnative', 'Ringcentral', 'Saicom', 'Samsung', 'Samsungpbx', 'Shoretel', 'Shoretelsky',
    'Shortelsky', 'Siemens', 'Sipgate', 'Skype For Business', 'Skyswicth', 'Skyswitch', 'Snet', 'Snom',
    'Softphone', 'Splicecom', 'Stage2', 'Switchvox', 'Symmetry', 'Telekom Slovenije', 'Telekomslovenije',
    'Telekonslovenije', 'Telepo', 'Telesphere', 'Telnetworldwide', 'Telstra', 'Thinkingphones', 'Threecom',
    'Threecx', 'Toshiba', 'Trixbox', 'Trumobility', 'Twilio', 'Unify', 'Verizon', 'Verizon Enterprise',
    'Voiplogic', 'Voipstudio', 'Vonage', 'Voxter', 'Yealink', 'Yeastar', 'Zayo',
    'Aitech', 'Amcom', 'Charterbusiness', 'Dsci', 'Esi', 'Evaluation', 'Example Bsp',
    'Fusion', 'Gts', 'Iptimi', 'Lgpbx', 'M5pbx', 'Mcm', 'Novum', 'Piaf', 'Rcnative',
    'Softphone', 'Symmetry', 'Telepo', 'Telesphere', 'Thinkingphones', 'Threecom',
    'Virtual Phone Pbx', 'Voipdito', 
].sort();

const chats = [
    'LivePerson', 'Live Chat', 'Olark', 'Oracle', 'RightNow', 'LiveAgent', 'Zopim',
].sort();

module.exports = {
    getAll() {
        return Promise.resolve({
            crms: crms,
            phones: phones,
            chats: chats,
        });
    }
};



//////////////////
// WEBPACK FOOTER
// ./src/js/services/SystemsService.js
// module id = 100
// module chunks = 0